module.exports = __webpack_public_path__ + "static/media/iconocargarfoto.729aa2d0.svg";